module.exports = __webpack_public_path__ + "assets/img/bind_bg.08ef54f0.png";